// extracted by mini-css-extract-plugin
module.exports = {"root":"MainTabs_root__1_tVb","stuck":"MainTabs_stuck__3Y-Gx","content":"MainTabs_content__GhNQ_","tab":"MainTabs_tab__1RS3N","is-selected":"MainTabs_is-selected__1kkh9"};